import { translate } from "app/filters/i18nFilter";
import type { EKeywordTabs } from "app/UtilitiesAndConstants/Constants/SourceTypes";

import type { IGraphTitles } from "app/common/keyword-research/clicks-over-time-graph/graphDataUtils";
import type { EntityKey } from "app/common/keyword-research/serp-players/consts";
import {
    TABLE_COLUMN_AVG_COMPETITION,
    TABLE_COLUMN_AVG_DIFFICULTY,
    TABLE_COLUMN_CHANGE,
    TABLE_COLUMN_COMPETITION,
    TABLE_COLUMN_CPC,
    TABLE_COLUMN_DIFFICULTY,
    TABLE_COLUMN_INTENT,
    TABLE_COLUMN_KEYWORD,
    TABLE_COLUMN_KEYWORDS,
    TABLE_COLUMN_MONTHLY_VOLUME,
    TABLE_COLUMN_ORGANIC_CLICKS_SHARE,
    TABLE_COLUMN_SELECTION,
    TABLE_COLUMN_TOTAL_WINDOW_VOLUME,
    TABLE_COLUMN_TOTAL_MONTHLY_VOLUME,
    TABLE_COLUMN_WEB_SOURCE_SHARE,
    TABLE_COLUMN_SHARE,
    TABLE_COLUMN_URL,
    TABLE_COLUMN_WINDOW_VOLUME,
    TABLE_COLUMN_TOP_KEYWORD,
    TABLE_COLUMN_SERP_FEATURES,
    TABLE_COLUMN_TOP_INTENT,
} from "app/common/keyword-research/serp-players/consts";

export const GRAPH_DASHBOARD_METRIC = "UrlClicksOverTime";
export const TABLE_DASHBOARD_METRIC = "UrlTrafficBreakdown";

export const entity: EntityKey = "URL";
export const SourceTypeMap: Record<keyof typeof EKeywordTabs, string> = {
    Organic: "organic",
    Paid: "paid",
    Total: "all",
};

export const visibleColumnsEnrich: string[] = [
    TABLE_COLUMN_SELECTION,
    TABLE_COLUMN_KEYWORD,
    TABLE_COLUMN_SHARE,
    TABLE_COLUMN_CHANGE,
    TABLE_COLUMN_INTENT,
    TABLE_COLUMN_DIFFICULTY,
    TABLE_COLUMN_CPC,
    TABLE_COLUMN_ORGANIC_CLICKS_SHARE,
    TABLE_COLUMN_SERP_FEATURES,
    TABLE_COLUMN_COMPETITION,
    TABLE_COLUMN_MONTHLY_VOLUME,
    TABLE_COLUMN_WINDOW_VOLUME,
];

export const graphTitles: IGraphTitles = {
    inputPlaceholder: "common.placeholder.search.url",
    subTitleSelected: "keywordanalysis.organic2.clicks.over.time.url.selected",
    labelTitle: "keywordanalysis.organic2.clicks.over.time.url",
    tooltipTitle: "keywordanalysis.organic2.clicks.over.time.tooltip.url",
};
export const dropDownColumnsTexts = {
    get openUrlTitle() {
        return translate("search.pages.table.columns.open");
    },
    get copyUrlTitle() {
        return translate("search.pages.table.columns.copy");
    },
    get exploreUrlKeywords() {
        return translate("search.pages.table.columns.explore");
    },
    get successToast() {
        return translate("keywordResearch.pages.table.copy.success");
    },
    get errorToast() {
        return translate("keywordResearch.pages.table.copy.error");
    },
};

export const visibleColumns: (isKeywordGroup: boolean) => string[] = (isKeywordGroup) => [
    TABLE_COLUMN_SELECTION,
    TABLE_COLUMN_URL,
    TABLE_COLUMN_KEYWORDS,
    TABLE_COLUMN_SHARE,
    TABLE_COLUMN_CHANGE,
    TABLE_COLUMN_WEB_SOURCE_SHARE,
    TABLE_COLUMN_ORGANIC_CLICKS_SHARE,
    TABLE_COLUMN_SERP_FEATURES,
    ...(isKeywordGroup
        ? [
              TABLE_COLUMN_TOP_KEYWORD,
              TABLE_COLUMN_TOTAL_MONTHLY_VOLUME,
              TABLE_COLUMN_TOTAL_WINDOW_VOLUME,
              TABLE_COLUMN_TOP_INTENT,
              TABLE_COLUMN_AVG_DIFFICULTY,
              TABLE_COLUMN_AVG_COMPETITION,
          ]
        : []),
];
